import React from 'react';
import { Expert } from '../section/MapSection';
import * as styles from './practitionerCard.module.scss';
import { LogoStarMap } from '../arrow/LogoStarMap';
import Pin from '../../../static/svg/poi.svg';
import Phone from '../../../static/svg/phone.svg';

interface Props {
  data: Expert;
  darkMode?: boolean;
  onClick: () => void;
}

export const PractitionerCard = ({ data, darkMode, onClick }: Props) => {
  return (
    <div
      className={`${styles.wrapper} ${darkMode && styles.blackBg}`}
      onClick={onClick}
    >
      <header>
        <h3>{data.practiceName}</h3>
        <LogoStarMap
          color={data.color}
          dark={darkMode}
        />
      </header>
      <div
        className={styles.address}
        data-type={data.color}
      >
        <Pin />
        <p>{`${data.address}${data.city ? `, ${data.city}` : ''}${
          data.zipcode ? ` (${data.zipcode})` : ''
        }`}</p>
      </div>
      <div
        className={`${styles.phone} ${data.phone && styles.visible}`}
        data-type={data.color}
      >
        <Phone />
        <a href={`tel:${data.phone}`}>{data.phone}</a>
      </div>

      <p className={styles.category}>{data.expertises}</p>
    </div>
  );
};
